import Seo from "../components/Seo";
import { Navbar } from "../components/landing/Navbar";
import { Hero } from "../components/landing/Hero";
import { Intro } from "../components/landing/Intro";
import { WhyUs } from "../components/landing/WhyUs";
import { Services } from "../components/landing/Services";
import { TrustBadges } from "../components/landing/TrustBadges";
import { Contact } from "../components/landing/Contact";
import { Footer } from "../components/landing/Footer";

export default function Landing() {
    return (
        <div className="bg-white">
            <Seo
                title="Stabilor — Lakásfelújítás, Gépészet, Villany, Napelem"
                description="Prémium napelemes rendszerek, teljes körű lakásfelújítás, épületgépészet és villanyszerelés Budapesten és országszerte. 20+ év tapasztalat, kulcsrakész kivitelezés, garanciális munkavégzés, ingyenes konzultáció."
                path="/"
            />
            <Navbar />
            <main>
                <Hero />
                <Intro />
                <WhyUs />
                <Services />
                <TrustBadges />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}
